/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValuesAggregationRequestDto
 */
export interface MetricValuesAggregationRequestDto {
    /**
     * Start date for filtering metric values (ISO 8601 format)
     * @type {string}
     * @memberof MetricValuesAggregationRequestDto
     */
    startDate?: string;
    /**
     * End date for filtering metric values (ISO 8601 format)
     * @type {string}
     * @memberof MetricValuesAggregationRequestDto
     */
    endDate?: string;
    /**
     * Filter by specific metric code
     * @type {string}
     * @memberof MetricValuesAggregationRequestDto
     */
    metricCode: MetricValuesAggregationRequestDtoMetricCodeEnum;
    /**
     * Filter by specific health provider code
     * @type {string}
     * @memberof MetricValuesAggregationRequestDto
     */
    healthProviderCode?: MetricValuesAggregationRequestDtoHealthProviderCodeEnum;
    /**
     * Group metric values by time interval for aggregation. Only metrics with integer or float data types support interval aggregation.
     * @type {string}
     * @memberof MetricValuesAggregationRequestDto
     */
    interval: MetricValuesAggregationRequestDtoIntervalEnum;
    /**
     * Order results by startDate
     * @type {string}
     * @memberof MetricValuesAggregationRequestDto
     */
    orderBy?: MetricValuesAggregationRequestDtoOrderByEnum;
    /**
     * Types of aggregation to perform on metric values
     * @type {Array<string>}
     * @memberof MetricValuesAggregationRequestDto
     */
    aggregateTypes?: Array<MetricValuesAggregationRequestDtoAggregateTypesEnum>;
}


/**
 * @export
 */
export const MetricValuesAggregationRequestDtoMetricCodeEnum = {
    StepCounts: 'step-counts',
    Distance: 'distance',
    ActiveCalories: 'active-calories',
    Workouts: 'workouts',
    FloorClimbed: 'floor-climbed',
    HeartRate: 'heart-rate',
    HeartRateVariability: 'heart-rate-variability',
    BloodOxygenSaturation: 'blood-oxygen-saturation',
    RespiratoryRate: 'respiratory-rate',
    RestingHeartRate: 'resting-heart-rate',
    BasalMetabolicRate: 'basal-metabolic-rate',
    BodyTemperature: 'body-temperature',
    BloodPressure: 'blood-pressure',
    BloodGlucose: 'blood-glucose',
    Weight: 'weight',
    Height: 'height',
    WaistCircumference: 'waist-circumference',
    HipCircumference: 'hip-circumference',
    BodyMassIndex: 'body-mass-index',
    BodyFatPercentage: 'body-fat-percentage',
    LeanBodyMass: 'lean-body-mass',
    BoneMass: 'bone-mass',
    SleepAnalysis: 'sleep-analysis',
    SleepStages: 'sleep-stages',
    SleepSessionEvents: 'sleep-session-events',
    TimeInBed: 'time-in-bed',
    SleepTime: 'sleep-time',
    ActualSleepTime: 'actual-sleep-time',
    Nutrition: 'nutrition',
    Calories: 'calories',
    Protein: 'protein',
    Carbohydrates: 'carbohydrates',
    TotalFat: 'total-fat',
    SaturatedFat: 'saturated-fat',
    MonounsaturatedFat: 'monounsaturated-fat',
    PolyunsaturatedFat: 'polyunsaturated-fat',
    Cholesterol: 'cholesterol',
    Micronutrients: 'micronutrients',
    Hydration: 'hydration',
    Menstruation: 'menstruation',
    OvulationTestResults: 'ovulation-test-results',
    WellBeing: 'well-being'
} as const;
export type MetricValuesAggregationRequestDtoMetricCodeEnum = typeof MetricValuesAggregationRequestDtoMetricCodeEnum[keyof typeof MetricValuesAggregationRequestDtoMetricCodeEnum];

/**
 * @export
 */
export const MetricValuesAggregationRequestDtoHealthProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type MetricValuesAggregationRequestDtoHealthProviderCodeEnum = typeof MetricValuesAggregationRequestDtoHealthProviderCodeEnum[keyof typeof MetricValuesAggregationRequestDtoHealthProviderCodeEnum];

/**
 * @export
 */
export const MetricValuesAggregationRequestDtoIntervalEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;
export type MetricValuesAggregationRequestDtoIntervalEnum = typeof MetricValuesAggregationRequestDtoIntervalEnum[keyof typeof MetricValuesAggregationRequestDtoIntervalEnum];

/**
 * @export
 */
export const MetricValuesAggregationRequestDtoOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type MetricValuesAggregationRequestDtoOrderByEnum = typeof MetricValuesAggregationRequestDtoOrderByEnum[keyof typeof MetricValuesAggregationRequestDtoOrderByEnum];

/**
 * @export
 */
export const MetricValuesAggregationRequestDtoAggregateTypesEnum = {
    Sum: 'sum',
    Min: 'min',
    Max: 'max',
    LatestRecord: 'latest-record'
} as const;
export type MetricValuesAggregationRequestDtoAggregateTypesEnum = typeof MetricValuesAggregationRequestDtoAggregateTypesEnum[keyof typeof MetricValuesAggregationRequestDtoAggregateTypesEnum];


/**
 * Check if a given object implements the MetricValuesAggregationRequestDto interface.
 */
export function instanceOfMetricValuesAggregationRequestDto(value: object): value is MetricValuesAggregationRequestDto {
    if (!('metricCode' in value) || value['metricCode'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    return true;
}

export function MetricValuesAggregationRequestDtoFromJSON(json: any): MetricValuesAggregationRequestDto {
    return MetricValuesAggregationRequestDtoFromJSONTyped(json, false);
}

export function MetricValuesAggregationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValuesAggregationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'metricCode': json['metricCode'],
        'healthProviderCode': json['healthProviderCode'] == null ? undefined : json['healthProviderCode'],
        'interval': json['interval'],
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'aggregateTypes': json['aggregateTypes'] == null ? undefined : json['aggregateTypes'],
    };
}

export function MetricValuesAggregationRequestDtoToJSON(json: any): MetricValuesAggregationRequestDto {
    return MetricValuesAggregationRequestDtoToJSONTyped(json, false);
}

export function MetricValuesAggregationRequestDtoToJSONTyped(value?: MetricValuesAggregationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'metricCode': value['metricCode'],
        'healthProviderCode': value['healthProviderCode'],
        'interval': value['interval'],
        'orderBy': value['orderBy'],
        'aggregateTypes': value['aggregateTypes'],
    };
}

